'use client'

import { useMutation } from '@apollo/client'
import { Button, Label, RadioGroup, RadioGroupItem } from '@chain-zen/ui'
import { toast } from 'sonner'

import { useWorkspaceSetup } from '../../contexts/setup-workspace-context'
import { SEND_VERIFICATION_CODE } from '../../data/mutations/workspace'
import { useSetupWorkspaceModal } from '../../stores/setup-workspace-modal-store'
import { ReceiveCodeMethodEnum } from '../../types/company'
import { SetupWorkspaceLayout } from './setup-workspace-layout'

/**
 * This component is used to select the receive code method for the phone - SMS or Phone Call.
 */
export const ReceiveCodeMethodForPhone = () => {
  const { setStep, receiveCodeMethod, setReceiveCodeMethod, verificationMethod } = useWorkspaceSetup()

  const { workspaceID } = useSetupWorkspaceModal()

  const [sendVerificationCode, { loading, error }] = useMutation(SEND_VERIFICATION_CODE, {
    onCompleted: () => {
      setStep(8) // Setting the step to 8 will trigger the next step in the setup process which is the VerificationOTP component.
    },
    onError: (err) => {
      toast.error(err.message)
    }
  })

  const handleClick = async () => {
    const input = {
      method: receiveCodeMethod,
      type: verificationMethod?.type
    }
    await sendVerificationCode({
      context: {
        headers: {
          'ws-id': workspaceID || ''
        }
      },
      variables: input
    })
  }

  return (
    <SetupWorkspaceLayout
      title="How do you want to receive the code?"
      footer={{
        label: 'Go Back',
        onClick: () => setStep(5)
      }}
    >
      <RadioGroup
        onValueChange={setReceiveCodeMethod}
        defaultValue={receiveCodeMethod}
        className="mt-4"
        id="receiveCodeMethod"
        name="receiveCodeMethod"
      >
        <div className="flex items-center space-x-2">
          <RadioGroupItem value={ReceiveCodeMethodEnum.SMS} id={ReceiveCodeMethodEnum.SMS} />
          <Label htmlFor="SMS">Text message</Label>
        </div>
        <div className="flex items-center space-x-2 mt-2">
          <RadioGroupItem value={ReceiveCodeMethodEnum.PhoneCall} id={ReceiveCodeMethodEnum.PhoneCall} />
          <Label htmlFor="PhoneCall">Phone call</Label>
        </div>
      </RadioGroup>
      {!!error?.message && <Label className="text-red-500">{error?.message}</Label>}
      <Button className="w-full mt-4" onClick={handleClick} loading={loading}>
        Next
      </Button>
    </SetupWorkspaceLayout>
  )
}
